export default {
  type: 'service_authorization_cap_rule',
  config: {
    relationships: {
      fee_schedule_program: {
        type: 'fee_schedule_program'
      },
      service_authorization_cap_group: {
        type: 'service_authorization_cap_group'
      }
    }
  }
};
//# sourceMappingURL=service_authorization_cap_rule.js.map